import { ExamDistributionAvailableQSetList } from '@exam-center/exam-distribution-list';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Flex, Paper, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ExamDistributionAvailableQSetsPage() {
  return (
    <PermissionGuard
      requiredPermission={APP_PERMISSIONS.ADMIN_EXAM_DISTRIBUTION.AVAILABLE_QSETS.VIEW}
    >
      <Flex sx={{ p: (theme) => theme.spacing(6), flexGrow: 1, width: '100%' }}>
        <PaperSection title='ชุดข้อสอบที่พร้อมใช้'>
          <Paper
            sx={(theme) => ({
              borderRadius: theme.shape.rounded(2),
              display: 'flex',
              flexDirection: 'column',
              gap: theme.spacing(6),
              height: '100%',
              padding: theme.spacing(6),
              width: '100%',
            })}
          >
            <ExamDistributionAvailableQSetList />
          </Paper>
        </PaperSection>
      </Flex>
    </PermissionGuard>
  );
}
